import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import CreateWidgetMutation from '../../../../../../mutations/CreateWidgetMutation';
import WidgetForm from '../../../../../../components/WidgetForm';

const initialState = {
  widget: {
    name: null,
    type: null,
    config: {
      filterComments: null,
      sliceByQuestion: null,
      aggregateQuestions: null,
      subtitle: null,
      ignoreDateFilter: null,
      showLastXMonths: null,
      hideHeader: null,
      hideCommentTime: null,
      staticYAxisScale: null,
      commentExtraColumns: null,
      question: null,
    },
  },
  allowSave: false,
};

class CreateWidgetDialog extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, initialState);
  }

  handleFormChange = (widget, allowSave) => {
    this.setState({widget, allowSave});
  };

  save = () => {
    CreateWidgetMutation.commit(Object.assign({}, this.state.widget, {reportId: this.props.report.id}));
    this.setState(Object.assign({}, initialState));
    this.props.onClose();
  };

  cancel = () => {
    this.setState(Object.assign({}, initialState));
    this.props.onClose();
  };

  render() {
    const dialogActions = [
      <FlatButton 
        label="Cancel"
        onTouchTap={this.cancel}
      />,
      <RaisedButton 
        label="Save"
        primary={true}
        onTouchTap={this.save}
        disabled={!this.state.allowSave}
      />,
    ];
    return (
      <Dialog
        title="Add a new widget to this report"
        open={this.props.open}
        autoScrollBodyContent={true}
        actions={dialogActions}
        onRequestClose={this.props.onClose}
      >
        <WidgetForm
          surveys={this.props.surveys}
          widget={this.state.widget}
          onChange={this.handleFormChange}
        />
      </Dialog>
    );
  }
}

export default createFragmentContainer(
  CreateWidgetDialog,
  graphql`
    fragment CreateWidgetDialog_report on Report {
      id
    }
    fragment CreateWidgetDialog_surveys on SurveyConnection {
      ...WidgetForm_surveys
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/CreateWidgetDialog/CreateWidgetDialog.js